import {
  getExcludedGifts,
  getIsComboGiftAnimationEnabled,
} from "src/features/gifts/giftsSoc";
import { giftsCacheSelectors } from "src/features/gifts/imports/selectors";
import { RootState } from "src/features/gifts/imports/types";
import { getFreeFollowGiftId } from "src/state/abTests";
import { SpecialKind } from "src/types/gift";

const EXCLUDED_GIFT_TYPES = [
  SpecialKind.AI_GIFT,
  SpecialKind.AR_GIFT,
  SpecialKind.GAME,
  SpecialKind.MEDIA,
  SpecialKind.TANGO_CARD,
];

export const getIsComboEnabledByGiftId = (state: RootState, giftId: string) => {
  const isComboEnabled = getIsComboGiftAnimationEnabled(state);
  const gift = giftsCacheSelectors.getGiftById(state, giftId);
  const isExcludedGift =
    getExcludedGifts(state).includes(giftId) ||
    EXCLUDED_GIFT_TYPES.includes(gift?.special);
  const isFreeFollowGift = giftId === getFreeFollowGiftId(state);

  return isComboEnabled && !isExcludedGift && !isFreeFollowGift;
};
